import { render, staticRenderFns } from "./VuetableFieldHandle.vue?vue&type=template&id=381a084a"
import script from "./VuetableFieldHandle.vue?vue&type=script&lang=js"
export * from "./VuetableFieldHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports